export default function scrollToTop() {
  window.scrollTo({
    top: 0,
    behavior: "smooth", // Adds a smooth scrolling effect
  });
}
